/**
 * import react
 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * import material-ui
 */
import Paper from '@material-ui/core/Paper';
import Tabel from '@material-ui/core/Table';
import TabelHead from '@material-ui/core/TableHead';
import TabelBody from '@material-ui/core/TableBody';

/**
 * import components
 */
import SlotTableHeadRow from './slot-table-head-row';
import SlotTableBodyRow from './slot-table-body-row';

const SlotTable = (props) => {
  const { list = [], selectedIdx = -1, handleSlotListRowSelected, handleTestedSlot, handleUpdateComment, handleRtspPreferred } = props || {};
  return (
    <Paper>
      <Tabel>
        <TabelHead>
          <SlotTableHeadRow />
        </TabelHead>
        <TabelBody>
          {
            list.map((slot, rIdx) => {
              const { ui = {} } = slot;
              const { isDisabled = false } = ui;
              const isChecked = !isDisabled && (selectedIdx === rIdx);
              const props = { rIdx, slot, isChecked, handleSlotListRowSelected, handleTestedSlot, handleUpdateComment, handleRtspPreferred };
              return (
                <SlotTableBodyRow key={rIdx} {...props}/>
              );
            })
          }
        </TabelBody>
      </Tabel>
    </Paper>
  );
};

SlotTable.propTypes = {
  list: PropTypes.array.isRequired,
  selectedIdx: PropTypes.number.isRequired,
  handleSlotListRowSelected: PropTypes.func.isRequired,
  handleTestedSlot: PropTypes.func.isRequired,
  handleUpdateComment: PropTypes.func.isRequired
};

export default React.memo(SlotTable);
